const initialState = {
  dashboard: [],
  error: null,
  fetching: false
}

const  dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "dashboard/fetching":
      return {
        ...state,
        fetching: true,
        error: null
      };
    case "dashboard":
      return {
        ...state,
		    dashboard: action.data,
        error: null,
        fetching: false
      };
    case "dashboard/error":
      return {
      ...state,
      error: action.error,
      fetching: false
    }
    default:
      return state
  }
}

export default dashboardReducer;
